import React, { Component } from 'react'
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap'

import { BootstrapTable } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

import RemovalDialog from '../RemovalDialog'

class SmartTable extends Component {

  state = {
    showRemoveModal: false,
    selected: {}
  }

  toggleSelection = item => {

    const selectionState = this.state.selected
    if(selectionState.hasOwnProperty(item.id)) {
      delete selectionState[item.id]
    }
    else {
      selectionState[item.id] = item
    }

    this.setState({
      selected: selectionState
    })
  }

  getSelectedItems = () => {
    let itemsArray = []
    const selectionState = this.state.selected

    for(let key in selectionState) {
      if(selectionState.hasOwnProperty(key)) {
        itemsArray.push(selectionState[key])
      }
    }

    return itemsArray
  }

  closeRemoveModal = () => this.setState({ showRemoveModal: false })

  showRemoveDialog = () => this.setState({ showRemoveModal: true })

  confirmRemoval = () => {
    const ids = this.getSelectedItems().map(x => x.id)
    this.props.onConfirmRemoval(ids)
    this.closeRemoveModal()
    this.setState({ selected: {} })
  }

  getItemsToRemove = () => this.getSelectedItems().map(item => this.props.renderItemToRemove(item))

  renderContent = () => {

    const options = {
      sortName: 'id',
      sortOrder: 'desc'
    },

    { items, children, buttonsDisable, addNewLabel, addNewHandler } = this.props

    return (
      <div>

        <BootstrapTable data={items} striped={true} hover={true} options={options} condensed pagination>
          { children }
        </BootstrapTable>
        <br />

        { buttonsDisable ? "" :
          <ButtonToolbar className='tableToolbar'>
            <Button bsStyle='primary' onClick={ addNewHandler }>{ addNewLabel }</Button>
            <Button bsStyle='danger' onClick={ this.showRemoveDialog } disabled={ this.getSelectedItems().length === 0 }>
              Remove selected
            </Button>
          </ButtonToolbar>
        }

        <RemovalDialog
          items={ this.getItemsToRemove() }
          title='Remove items?'
          show={ this.state.showRemoveModal }
          close={ this.closeRemoveModal }
          confirmRemoval={ this.confirmRemoval }
        />
      </div>
    )
  }

  render() {
    return this.props.loading ? <p>Loading...</p> : this.renderContent()
  }
}

export default SmartTable



// WEBPACK FOOTER //
// ./src/components/SmartTable/index.js